<template>

    <section>
        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            EndUserModalWithPromise
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="modal_container confirm" :class="className">
            <div class="wrap">
                <!-- Title -->
                <div v-if="title" class="title">
                    <h3><span>{{title}}</span></h3>
                </div>

                <!-- Text -->
                <div class="text-wrap">
                    <div class="inner" >

                        <!-- Body -->
                        <div class="modal_body">
                            <div v-if="message" class="inner">
                                <p>{{message}}</p>
                            </div>
                        </div>

                        <!-- Button -->
                        <div class="button-wrap" style="text-align: center; display:block;">
                            <button type="button" class="cancel" @click="onCancel"><span>キャンセル</span></button>
                            <button type="button" v-if="mode=='delete'" class="" @click="onConfirm"><span>削除</span></button>
                            <button type="button" v-if="mode=='confirm'" class="" @click="onConfirm"><span>OK</span></button>
                        </div><!-- /.button-wrap -->

                    </div><!-- /.Inner -->
                </div><!-- /.Text -->
                <div class="close-icon"><span></span><span></span></div>
            </div><!-- /.Wrap -->
            <div class="modal_close-ovl" v-on:click="coolClose"></div>
        </div><!-- /.ModalContainer -->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            ModalBackGround
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <!-- <div class="modal_bg _confirm"></div> -->

        <!-- ここまで -->


        <!-- モーダル要素 ここまで -->

    </section>

</template>

<style>
._center {
    text-align: center;
    display:block;
}
</style>

<script>
    import commonMixins from '@/common/utility.js'

    //Svg
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'

    export default {
        mixins: [commonMixins],
        components: {
            //Svg
            SvgIconCheck,
            SvgIconCancel,
            SvgIconDelete
        },
        data() {
            return {
                resolvePromise: undefined,
                rejectPromise: undefined,
                title: String,
                message: String,
                mode: String,
                name: String //複数のconfirm modalの場合uniqueなclassではないと違うものが表示されるから
            }
        },
        computed: {
            classObject() {
                return {
                    '_delete': this.mode === "delete"
                }
            },
            className(){
                return this.name;
            }
        },
        methods: {
            show(opts = {}) {
                this.title = opts.title;
                this.message = opts.message;
                this.mode = opts.mode;
                this.name = opts.name;
                setTimeout(this.coolOpen, 200);    
                return new Promise((resolve, reject) => {
                    this.resolvePromise = resolve;
                    this.rejectPromise = reject;
                })
            },
            onCancel(){
                this.resolvePromise(false);
                this.coolClose();
            },
            onConfirm(){
                this.resolvePromise(true);
                this.coolClose();
            },
            coolOpen(){
                $(`.modal_container.confirm.${this.name}`).addClass('_open');
                $('.modal_bg._confirm').addClass('_on');
            },
            coolClose(){
                $(`.modal_container.confirm.${this.name}`).removeClass('_open');
                $('.modal_bg._confirm').removeClass('_on');
            }
        }
    }
</script>